<template>
  <div>
    <el-row>
      <el-col :span="spanNum" class="publications-wrap">
        <post-common :selected-start-time="selectedStartTime" :selected-end-time="selectedEndTime" :dates="dates" :key="dates.date_from" v-if="postsList.length" :socialOptions="socialOptions" :selectedSocial="selectedSocial"/>

<!--      <div class="icon-flex" v-if="!showSidebar" @click="showSidebar = true">-->
<!--        <i class="material-icons icon-btn">-->
<!--          filter_alt-->
<!--        </i>-->
<!--      </div>-->
<!--      <div v-if="showSidebar" class="icon-flex" @click="showSidebar = false">-->
<!--        <i class="material-icons icon-btn">-->
<!--          filter_alt_off-->
<!--        </i>-->
<!--      </div>-->
        <el-button type="primary" v-if="showSideBarButton" class="show-sidebar-button" icon="el-icon-setting" circle @click="setShowSidebar"></el-button>
        <el-tabs class="posts-type" v-model="activeTabName" @tab-click="tabClick">
          <el-tab-pane :label="$t('publicationsAndCommentsTabs.posts.title')" :name="$t('publicationsAndCommentsTabs.posts.name')">
<!--            <search-post @setSearch="setSearch" :search="search"/>-->
            <posts
              v-if="active"
              v-loading="loading"
              :posts="postsList"
              @loadPosts="loadPosts"
              @showMore="showMore"
              @toggleComment="toggleComment"
              @setTrust="setTrust"
              @addStopPost="addStopPost"
              @removeStopPost="removeStopPost"
              @addAllCopyStopPost="addAllCopyStopPost"
              @removeAllCopyStopPost="removeAllCopyStopPost"
              :excluded="true"
              :addPostToEvent="true"
              @addPostTo="addPostTo"
              @setTrustAllPage="setTrustAllPage"
              :setTrustAllPageCompleted="setTrustAllPageCompleted"
            />
            <div class="posts-pagination">
              <el-pagination
                  layout="prev, pager, next"
                  :total="postsCount"
                  :page-size="postsLimit"
                  @current-change="pageChange"
                  :hide-on-single-page="true"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('publicationsAndCommentsTabs.excluded.title')" :name="$t('publicationsAndCommentsTabs.excluded.name')">
            <posts
              v-if="active"
              v-loading="excludedLoading"
              :posts="excludedList"
              @loadPosts="loadPosts"
              @showMore="showMore"
              @toggleComment="toggleComment"
              @removeAllCopyStopPost="removeAllCopyStopPost"
              @setTrust="setTrust"
              @addToAllPost="addToAllPost"
              :excluded="false"
            />
            <div class="posts-pagination">
              <el-pagination
                  layout="prev, pager, next"
                  :total="excludedCount"
                  :page-size="postsLimit"
                  @current-change="excludedPageChange"
                  :hide-on-single-page="true"
              >
              </el-pagination>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('publicationsAndCommentsTabs.reports.title')" :name="$t('publicationsAndCommentsTabs.reports.name')">
            <report
              v-loading="loading"
              :csvLinkLight="csvLinkLight"
              :weekLink="weekLink"
              :dayLink="dayLink"
              :topSource="topSource"
              :fileDownloadLink="fileDownloadLink"
              :fileDownloadLinkExcel="fileDownloadLinkExcel"
              :dates="dates"
              @setDate="setDate"
              @loadPosts="loadPosts"
              @openCreateReportWindow="openCreateReportWindow"
            />
          </el-tab-pane>
        </el-tabs>
      </el-col>
      <el-col :span="6" class="sidebar-wrap" >
        <post-sidebar
          v-if="active"
          :socialOptions="socialOptions"
          :tonalOptions="tonal"
          :sort-options="sortOptions"
          :selected-sort="selectedSort"
          :selected-time="selectedTime"
          :selected-start-time="selectedStartTime"
          :selected-end-time="selectedEndTime"
          :selectedSocial="selectedSocial"
          :selectedTonal="selectedTonal"
          :reposts="has_reposts"
          :isFiltered="isFiltered"
          :showSidebar="showSidebar"
          :toDate="toDate"
          :fromDate="fromDate"
          @toggleDrawer="toggleDrawer"
          @setDate="setDate"
          @setSelected="setSelected"
          @setRePost="setRePost"
          @clearFilter="clearFilter"
          @loadPosts="apply"
          @reloadPosts="reloadPosts"
        />
      </el-col>

      <create-report @openCreateReportWindow="openCreateReportWindow" :reportDrawer="reportDrawer"/>
      <new-post :drawer="drawer" @toggleDrawer="toggleDrawer"/>
    </el-row>

    <el-dialog title="Добавление поста к событию" :visible.sync="outerVisible">
      <div class="select-action">
        <el-select v-model="eventsOptions.active" placeholder="Выберите действие">
          <el-option
            v-for="item in eventsOptions.items"
            :key="item.value"
            :label="item.title"
            :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="select-event" v-if="eventsOptions.active === 'current'">
        <el-select v-model="eventForPost" placeholder="Выберите событие">
          <el-option
            v-for="item in events"
            :key="item.id"
            :label="item.title"
            :value="item.id">
          </el-option>
        </el-select>
      </div>
      <div class="select-event" v-if="eventsOptions.active === 'toNew'">

        <new-event
          :form="form"
          @setForm="setForm"
          @setEventForm="setEventForm"
          :innerVisible="innerVisible"
          @setInnerVisible="setInnerVisible"
          @saveEvent="saveEvent"
        />

        <el-dialog
          title="Добавить событие на карте"
          :visible.sync="innerVisible"
          append-to-body
         >
            <ymap @setEvent="setEvent" :coords="userCityMapCoords" :onEvent="onEvent" @onEventAdd="onEventAdd"/>
          </el-dialog>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outerVisible = false">Отмена</el-button>
        <el-button type="primary" @click="addPostEvent">Добавить</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  /*
    publications and comments component from tabs directory of analytics
    use i18n locale
    see http://kazupon.github.io/vue-i18n/started.html for details

    компонент, который делался в режиме "нужно сделать на прошлой неделе"
    как впрочем и многие компоненты в проекте(((
    сори
  */

  // components
  import Posts from './components/Posts';
  import PostSidebar from './components/PostSidebar';
  import PostCommon from './components/PostCommon';
  import newPost from './components/newPost/newPost.vue';
  import Report from './components/report/Report.vue';
  import CreateReport from './components/creteReport/CreateReport';
  import SearchPost from './components/SearchPost';
  import NewEvent from './components/NewEvent';
  import Ymap from "@/components/yMap/Ymap";

  // helpers
  import {dateFrom, dateTo} from './components/helpers/dateHelper';
  // options
  import options from './components/options/sidebarOptions';
  // actions
  import {SET_PERIOD} from "../../../../../../store/actions/analytics";

  // libraries
  import moment from "moment/moment";

  // api
  import {addToAllPosts, addToStopPosts, getPostsApi, getStopPostsApi, setPostsTrustApi, getPostSiblings} from '@/api/publications';
  import  {
    getThreadEventsApi,
    addPostEventApi,
    saveEventApi,
  } from '@/api/events';

  //actions
  import { GET_TRUST } from "@/store/actions/analytics";
  import {mapGetters} from 'vuex';
  import {SET_GLOBAL_MAIN_PERIOD} from '@/store/actions/datePeriod';

  let MOBILE_WIDTH = 480;

  export default {
    name: "PublicationsAndComments",
    props: {
      active: {
        type: Boolean
      }
    },
    data() {
      return {
        form: {
          name: '',
          coord_line: '',
        },
        onEvent: false,
        innerVisible: false,
        events: [],
        eventForPost: null,
        activePost: null,
        eventsOptions: {
          items: [
            {
              title: 'Новое событие',
              value: 'toNew'
            },
            {
              title: 'К текущему',
              value: 'current'
            }
          ],
          active: ''
        },
        outerVisible: false,
        reportDrawer: false,
        drawer: false,
        excluded: [],
        posts: [],
        postsCount: 0,
        toDate: '',
        fromDate: '',
        postsLimit: 20,
        postsStart: 0,
        postLoad: true,
        excludedCount: 0,
        excludedStart: 0,
        selected_source: {},
        activeTabName: 'posts',
        search: '',
        csvLinkLight: '',
        weekLink: '',
        dayLink: '',
        topSource: '',
        fileDownloadLink: '',
        fileDownloadLinkExcel: '',
        loading: false,
        excludedLoading: false,
        dates: {
          date_from: dateFrom(),
          date_to: dateTo(),
        },
        social: this.$t('post.sidebar.options.social'),
        selectedSocial: this.$t('post.sidebar.options.social').map(item => item.label),
        tonal: this.$t('post.sidebar.options.tonal'),
        sortOptions: this.$t('post.sidebar.options.sortOptions'),
        selectedSort: null,
        selectedTonal: null,
        selectedTime: null,
        selectedStartTime: null,
        selectedEndTime: null,
        has_reposts: false,
        format: "YYYY-MM-DD HH:mm:ss",
        isFiltered: false,
        setTrustAllPageCompleted: false,
        showSidebar: true,
      };
    },
    computed: {
      ...mapGetters([
        'userCityMapCoords'
      ]),
      spanNum(){
        return this.showSidebar ? 18 : 24
      },
      feed() {
        return this.$store.getters['feed'](this.$route.params.threadId)
          ?
          this.$store.getters['feed'](this.$route.params.threadId)
          :
          [];
      },
      isKeyWordType() {
        return this.feed.threadtype === 'keywords';
      },
      headerNetworks() {
        return this.$store.getters['feedNetworks'](this.$route.params.threadId)
          ?
            this.$store.getters['feedNetworks'](this.$route.params.threadId)
          :
            [];
      },
      socialOptions() {
        let arr = []
        this.social.forEach(item => {
          if (this.isKeyWordType) {
            if (this.$store.getters['feedNetworks'](this.$route.params.threadId).indexOf(+item.value) != -1)
              arr.push(item);
          }
            else
              arr.push(item);
          })
        return arr
      },
      rePostOption() {
        if (this.has_reposts) {
          return {label: this.$t('post.rePostOption.repost'), value: 'containrepost'};
        }

        return {label: this.$t('post.rePostOption.all'), value:'whatever'};
      },
      postsList () {
        return this.getListByPostfix('posts');
      },
      excludedList () {
        return this.getListByPostfix('excluded');
      },
      showSideBarButton() {
        return this.loading ? false : true;
      },
    },
    methods: {
      apply(periodPayload) {
        if (periodPayload) {
          this.$store.dispatch(SET_GLOBAL_MAIN_PERIOD, periodPayload);
        }
        this.reloadPosts()
      },
      pageChange(pageNumber) {
        this.postsStart = (pageNumber - 1) * this.postsLimit;
        this.getPosts();
        window.scrollTo(0, 0);
      },
      excludedPageChange(pageNumber) {
        this.excludedStart = (pageNumber - 1) * this.postsLimit;
        this.getExcluded();
        window.scrollTo(0, 0);
      },
      saveEvent() {
        let params = {
          id: 0,
          thread_id: this.$route.params.threadId,
          title: this.form.name,
          coord_center: this.userCityMapCoords.join(','),
          coord_line: this.form.coord_line.replace(/\s/g, '')
        };
        saveEventApi(params).then((resp)=>{
          this.events.push({...resp.data, keywords: []});
          this.form.name = '';
          this.form.coord_line = '';
          this.eventsOptions.active = 'current';
        });
      },
      setForm(value) {
        this.form = {...this.form, ...value};
      },
      setEventForm(payload) {
        console.log(payload);
      },
      setEvent(coords) {
        this.form.coord_line = coords;
        this.innerVisible = false;
      },
      setInnerVisible() {
        this.innerVisible = !this.innerVisible;
      },
      addPostEvent(){
        if (this.eventsOptions.active === 'current') {
          let params = {
            event_id: this.eventForPost,
            post_id: this.activePost.id,
            owner_id: this.activePost.owner_id,
            network_id: this.activePost.network_id,
          };

          addPostEventApi(params).then(() => {
            this.eventForPost = null;
            this.activePost = null;
            this.outerVisible = false;
          })
        }
      },
      addPostTo(post) {
        this.activePost = post;
        this.outerVisible = true;
      },
      setShowSidebar() {
        if (window.innerWidth < MOBILE_WIDTH) {
          this.showSidebar = !this.showSidebar;
        }
      },
      openCreateReportWindow() {
        this.reportDrawer = !this.reportDrawer;
      },
      setExcelLink () {
        let fFrom = moment(this.dates.date_from).format("YYYY-MM-DD");
        let fTo = moment(this.dates.date_to).format("YYYY-MM-DD");
        let thread_id = this.$route.params.threadId;
        return `http://${!window.location.href.includes('test111') ? 'api' : 'apitest'}.glassen-it.com/component/socparser/content/comments_excell?thread_id=${thread_id}&from=${fFrom}&to=${fTo}`;
      },
      setWeekLink () {
        let fTo = moment(this.dates.date_to).format("YYYY-MM-DD");
        let minFrom = new Date(this.dates.date_to)
        let fFrom = moment(minFrom.setDate(minFrom.getDate() - 6)).format("YYYY-MM-DD");
        let thread_id = this.$route.params.threadId;
        return `http://${!window.location.href.includes('test111') ? 'api' : 'apitest'}.glassen-it.com/component/socparser/content/getReportMonitoring?thread_id=${thread_id}&from=${fFrom}&to=${fTo}`;
      },
      setDayLink () {
        let fFrom = moment(this.dates.date_from).format("YYYY-MM-DD");
        let fTo = moment(this.dates.date_to).format("YYYY-MM-DD");
        let thread_id = this.$route.params.threadId;
        return `http://${!window.location.href.includes('test111') ? 'api' : 'apitest'}.glassen-it.com/component/socparser/content/getReportAnalytic?thread_id=${thread_id}&date_from=${fFrom}&date_to=${fTo}`;
      },
      toggleDrawer() {
        this.drawer = !this.drawer;
      },
      getListByPostfix(postfix) {
        if (this.search.length > 3) {
          return this[postfix].filter(item => {
            if (item.text.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
              return item;
            }
          });
        } else {
          return this[postfix];
        }
      },
      addStopPost(post) {
        const params = {
          thread_id: this.$route.params.threadId,
          network_id: post.network_id,
          owner_id: post.owner_id,
          post_id: String(post.id),
        };

        addToStopPosts(params).then(() => {
          const posts = [...this.posts]
          posts.find(item => item.id === post.id).isRemoved = true

          this.posts = [...posts]
          // this.excluded.unshift(post);
        });
      },

      removeStopPost(post) {
        const params = {
          thread_id: this.$route.params.threadId,
          network_id: post.network_id,
          owner_id: post.owner_id,
          post_id: String(post.id),
        };

       addToAllPosts(params).then(() => {
          const posts = [...this.posts]
          posts.find(item => item.id === post.id).isRemoved = false

          this.posts = [...posts]
          // this.excluded.unshift(post);
        });
      },
      addAllCopyStopPost(posts) {
        const promises = []
        console.log('posts', posts)
        for (const post of posts) {
          const params = {
            thread_id: this.$route.params.threadId,
            network_id: post.network_id,
            owner_id: post.owner_id,
            post_id: String(post.id),
          };

          promises.push(addToStopPosts(params))
        }
        Promise.all(promises).then(() => {
          const postsNew = [...this.posts]
          const removedPosts = posts.map((post) => post.id)

          postsNew.forEach(item => {
            if (removedPosts.includes(item.id)) {
              item.isRemoved = true
            }
          })

          this.posts = [...postsNew]
        })
      },
      removeAllCopyStopPost(posts) {
        const promises = []
        for (const post of posts) {
          console.log('test 1', post)
          const params = {
            thread_id: this.$route.params.threadId,
            network_id: post.network_id,
            owner_id: post.owner_id,
            post_id: String(post.id),
          };

          promises.push(addToAllPosts(params))
        }
        Promise.all(promises).then(() => {
          const postsNew = [...this.posts]
          const removedPosts = postsNew.map((post) => post.id)

          postsNew.forEach(item => {
            if (removedPosts.includes(item.id)) {
              item.isRemoved = false
            }
          })

          this.excluded = [...postsNew]
        })
      },
      addToAllPost(post) {
        const params = {
          thread_id: this.$route.params.threadId,
          network_id: post.network_id,
          owner_id: post.owner_id,
          post_id: String(post.id),
        };

        addToAllPosts(params).then(() => {
          this.excluded = this.excluded.filter(item => item.id !== post.id);
          this.posts.unshift(post);
        });

      },
      tabClick(tab, event) {
        this.activeTabName = tab.name

        if (this.activeTabName === 'reports') {
          return;
        }

        this.reloadPosts()
      },
    setTrust({ postId, trust }) {
      const post = this.posts.find((item) => item.id === postId);

      const params = {
        id: postId,
        owner_id: post.owner_id,
        network_id: post.network_id,
        trust: trust,
      };

      const params3 = {
        post_id: postId,
        owner_id: post.owner_id,
        network_id: post.network_id,
        trust: trust,
      };

      getPostSiblings(params).then((resp) => {
        this.copyPostsTonal = resp.data.posts;
        if (resp.data.posts.length > 0)
          resp.data.posts.map((item) => {
            const params2 = {
              post_id: item.id,
              owner_id: item.owner_id,
              network_id: item.network_id,
              trust: trust,
            };
            setPostsTrustApi(params2).then(() => {
            this.posts = this.posts.map((item) => {
              if (item.id === postId) {
                item.trust.trust = trust;
              }

              return item;
            });
            });
          });
        else
          setPostsTrustApi(params3).then(() => {
            this.posts = this.posts.map((item) => {
              if (item.id === postId) {
                item.trust.trust = trust;
              }

              return item;
            });
          });
      })
      .catch(err => {
            setPostsTrustApi(params3).then(() => {
            this.posts = this.posts.map((item) => {
              if (item.id === postId) {
                item.trust.trust = trust;
              }

              return item;
            });
          });
      })
    },
      setTrustAllPage(trust) {
        const setPostsTrustPromises = []
        this.posts.forEach(post => {
          const params = {
            post_id: post.id,
            owner_id: post.owner_id,
            network_id: post.network_id,
            trust: trust
          };

          setPostsTrustPromises.push(setPostsTrustApi(params))
        });
        Promise.all(setPostsTrustPromises).then(() => {
            this.posts = this.posts.map(item => {
              item.trust.trust = trust;
              return item;
            });
            this.setTrustAllPageCompleted = true
        })
      },
      showMore(post) {
        post.showMore = !post.showMore;
      },
      toggleComment(post) {
        if (post.showComment === undefined) {
          this.$set(post, 'showComment', true);
          this.$set(post, 'firstLoad', true);
        } else {
          post.showComment = !post.showComment;
          post.firstLoad = false;
        }
      },
            socialOptions() {
        let arr = []
        this.social.forEach(item => {
          if (this.isKeyWordType) {
            if (this.$store.getters['feedNetworks'](this.$route.params.threadId).indexOf(+item.value) != -1)
              arr.push(item);
          }
            else
              arr.push(item);
          })
        return arr
      },
      getFilter() {
        let network = this.$store.getters['feedNetworks'](this.$route.params.threadId)
        // if (this.selectedSocial.length > 0 && this.selectedSocial.length !== this.socialOptions.length) {
        if (this.selectedSocial.length > 0) {
          network=[]
          this.selectedSocial.forEach(item => {
            let value = this.social.find(it => it.label === item).value
            if (this.isKeyWordType) {
              if (this.$store.getters['feedNetworks'](this.$route.params.threadId).indexOf(+value) !== -1)
                network.push(value);
            }
            else network.push(value);
          })
        }

        let trustoption = this.selectedTonal !== null ? this.selectedTonal : undefined;

        return {
          network_id: network,
          source_type: this.selected_source.network_id,
          profile_id: this.selected_source.profile_id,
          repostoption: this.rePostOption.value,
          trustoption,
        };
      },
      reloadPosts() {
        if (this.activeTabName === 'reports') {
          return;
        }

        if (this.activeTabName === 'posts') {
          this.posts = [];
          this.postsStart = 0;
          this.postLoad = true;
          this.loadPosts();
        }

        if (this.activeTabName === 'excluded') {
          this.excluded = [];
          this.excludedStart = 0;
          this.getExcluded();
        }
      },
      getExcluded() {
        this.excludedLoading = true;
        //this.excludedFirstLoad = true;

        let params = {
          thread_id: this.$route.params.threadId,
          limit: this.postsLimit,
          start: this.excludedStart,
        };
        getStopPostsApi(params).then((resp) => {
          //console.log('getStopPostsApi ', resp.data);
          resp.data.items = resp.data.items.map(item => {
            return Object.assign({}, item, { showMore: false });
          });
          this.excluded = [...resp.data.items];
          this.excludedStart = this.excludedStart + this.excluded.length;
          this.excludedCount = resp.data.count;
          this.excludedLoading = false;
        });
      },
      getPosts() {
        if (!this.postLoad) {
          return;
        }

        this.loading = true;
        let params = this.getParams();

        getPostsApi(params).then((resp) => {
          resp.data.posts = resp.data.posts.map(item => {
            return Object.assign({}, item, { showMore: false });
          });

          this.csvLinkLight = resp.data.csv_link_light;
          this.topSource = resp.data.user_link;
          this.fileDownloadLink = resp.data.csv_link;
          this.fileDownloadLinkExcel = this.setExcelLink();
          this.weekLink = this.setWeekLink();
          this.dayLink = this.setDayLink();
          this.posts = resp.data.posts;
          this.postsCount = +resp.data.count
          this.loading = false;
          this.fromDate = resp.data.date_from;
          this.toDate = resp.data.date_to;
          this.dates.date_from = this.isFiltered ?  this.dates.date_from : this.startDate;
          this.dates.date_to = this.isFiltered ?  this.dates.date_to : this.endDate;
        }).catch((err)=>{
            if (err.message.includes('417'))
            this.pageChange(1)
        });
      },
      getParams() {
        const period = this.$store.getters.getGlobalMainPeriod;

        let from = period[0];
        let to = period[1];

        let fromR = this.$store.getters.retrospective(this.$route.params.threadId);
        let toR = this.$store.getters.retro_max(this.$route.params.threadId);
        let end = new Date(toR);
        end.setDate(end.getDate() - 1);

        if (this.selectedStartTime) {
          from = from.split(' ');
          from = `${from[0]} ${moment(this.selectedStartTime).format('HH:mm:ss')}`;
        }

        if (this.selectedEndTime) {
          to = to.split(' ');
          to = `${to[0]} ${moment(this.selectedEndTime).format('HH:mm:ss')}`;
        }

        if (!this.selectedStartTime && !this.selectedEndTime) {
          to = to.split(' ');
          to = to[0] + ' ' + "23:59:59";
        }

        if (fromR && toR && from > toR) from = fromR + " 23:59:59"
        if (fromR && toR && to > toR) to = end.toJSON().split('T')[0] + " 00:00:00"

        return  {
          thread_id: this.$route.params.threadId,
          from,
          to,
          limit: this.postsLimit,
          start: this.postsStart,
          sort: this.selectedSort === null ? this.sortOptions[3].value : {type: this.selectedSort.type, order: this.selectedSort.order},
          filter: this.getFilter(),
        };
      },
      loadPosts() {
        if (this.activeTabName === 'reports') {
          return;
        }

        if (this.showSidebar) {
          this.setShowSidebar();
        }

        let method = this.activeTabName[0].toUpperCase() + this.activeTabName.slice(1);
        if (!this.loading) {
          this[`get${method}`]();
        }

      },
      clearFilter() {
        this.isFiltered = false;
        this.has_reposts = false;
        this.selectedSort = null;
        this.selectedTonal = null;
        this.selectedTime = null;
        this.selectedStartTime = null;
        this.selectedEndTime = null;
        this.selectedSocial = [];
        this.search = '';

        const endDate = new Date();
        const startDate = new Date();

        startDate.setHours(0);
        startDate.setMinutes(0);
        startDate.setSeconds(0);

        let period = [new Date(startDate), endDate];
        this.$store.dispatch(SET_PERIOD, {
          chart: 'Statistic',
          period: period.map(item => moment(item).format(this.format))
        });

        this.reloadPosts();
      },
      setSearch(value) {
        this.isFiltered = true;
        this.search = value;
      },
      setRePost(value) {
        this.isFiltered = true;
        this.has_reposts = value;
      },
      setSelected({postFix, value}) {
        this.isFiltered = true;
        this[`selected${postFix}`] = value;
      },
      setDate({postFix, value}){
        this.isFiltered = true;
        this.dates[`date_${postFix}`] = value;
        this.fileDownloadLinkExcel = this.setExcelLink();
        this.weekLink = this.setWeekLink();
        this.dayLink = this.setDayLink();
        let fFrom = moment(this.dates.date_from).format("YYYY-MM-DD") + " 00:00:00";
        let fTo = moment(this.dates.date_to).format("YYYY-MM-DD") + " 23:59:59";
        let thread_id = this.$route.params.threadId;
          this.csvLinkLight = `https://${!window.location.href.includes('test111') ? 'api' : 'apitest'}.glassen-it.com/component/socparser/content/posts_excell_light?thread_id=${thread_id}&from=${fFrom}&to=${fTo}&sort[type]=date&sort[order]=desc&filter[repostoption]=whatever&filter[network_id][0]=1&filter[network_id][1]=2&filter[network_id][2]=3&filter[network_id][3]=5&filter[network_id][4]=7&filter[network_id][5]=8&filter[network_id][6]=4`;
          this.topSource = `https://${!window.location.href.includes('test111') ? 'api' : 'apitest'}.glassen-it.com/component/socparser/stats/owners_rating?thread_id=${thread_id}&from=${fFrom}&to=${fTo}`;
          this.fileDownloadLink = `https://${!window.location.href.includes('test111') ? 'api' : 'apitest'}.glassen-it.com/component/socparser/content/posts_excell?thread_id=${thread_id}&from=${fFrom}&to=${fTo}&sort[type]=date&sort[order]=desc&filter[repostoption]=whatever&filter[network_id][0]=1&filter[network_id][1]=2&filter[network_id][2]=3&filter[network_id][3]=5&filter[network_id][4]=7&filter[network_id][5]=8&filter[network_id][6]=4`;
      },
    },
    mounted() {
      this.$store.dispatch(GET_TRUST, {chart: 'Statistic', thread: this.$route.params.threadId});
      this.loadPosts();
    },
    watch: {
      'eventsOptions.active'(value) {
        if (value === 'current') {
          let params = {
            thread_id: this.$route.params.threadId,
          };

          getThreadEventsApi(params).then(resp => {
            this.events = resp.data.filter(item => item.coord_line !== '');
          });
        }
      }
    },
    components: {
      Posts,
      PostSidebar,
      PostCommon,
      newPost,
      Report,
      CreateReport,
      SearchPost,
      NewEvent,
      Ymap,
    },
  };
</script>

<style>
  .icon-flex{
    display: flex;
    justify-content: right;
    margin: -10px 20px;
    cursor: pointer;
  }
  .icon-btn{
    box-shadow: 0 8px 15px rgb(0 0 0 / 10%);
    padding: 10px;
    cursor: pointer;
    border-radius: 25px;
  }
  .publications-wrap, .sidebar-wrap {
      padding: 0!important;
  }
  .sidebar-wrap {
    display: flex;
    justify-content: flex-end;
  }
  .show-sidebar-button {
    display: none;
  }

  .select-action {
    margin-bottom: 10px;
  }

  .posts-pagination {
    display: flex;
    justify-content: center;
    margin: 10px 0 0;
  }

  @media screen and (max-width: 480px) {
    .show-sidebar-button {
      display: block;
      position: fixed;
      bottom: 15px;
      right: 15px;
      z-index: 510;
      width: 55px;
      height: 55px;
    }
    .publications-wrap {
      width: 100%;
    }
    .publications-wrap .is-top{
      padding: 0 5px;
    }
    .post-common-list{
      padding: 0 10px;
      flex-wrap: wrap;
      justify-content: center;
    }
    .guides-references-keywords-edit-row .el-button {
      margin-top: 10px
    }
    .el-dialog{
      width: 80%;
    }
    .posts-type .el-tabs__nav-wrap{
      display: block;
    }
  }
</style>
